import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm from './DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './FilterFormConstants';

export function simpleToggleText(options: Array<OptionData>, value: string): string {
  const selectedOption = _.findWhere(options, {value});
  assert(Boolean(selectedOption), 'Expected `value` to represent a valid option');
  return selectedOption!.name as string;
}

export interface SingleValueDropdownFilterFormProps extends BaseFilterFormProps {
  filterStyle: FilterStyle;
  onRemove?: () => void;
  optionDatas: Array<OptionData>;
  // This component is intended for use in contexts where a filter value must always be chosen
  value: string;
  onChangeValue: (value: string) => void;
}

export default function SingleValueDropdownFilterForm(
  props: SingleValueDropdownFilterFormProps
): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      isActive={true} // always active since there is always a default value selected
      dropdownToggleText={simpleToggleText(props.optionDatas, props.value)}
      filterStyle={props.filterStyle}
      {...(props.filterStyle === FilterStyle.SECONDARY ? {onRemove: props.onRemove} : {})}
      isMulti={false}
      onChangeValue={(value: string) => {
        props.onChangeValue(value);
      }}
      optionDatas={props.optionDatas}
      value={props.value}
    />
  );
}
